const mmpworld = {
	image: 'mmpworld.jpg',
	path: '/mmpworld',
	name: 'Plans',
	title: (
		<span>
			The Market Maker Plans <br />
			MMP WORLD
		</span>
	),
	description:
		'MMP WORLD establishes a crowdfunding and market-making system to support BEM Foundation projects with transparency and real-world growth.',
	content: (theme) => (
		<div className='container py-5'>
			<div
				id='mmp_main'
				className='row'>
				<div className='col-12'>
					<h2>Market Maker Plan – MMP WORLD</h2>
					<p>
						Launched on August 12, 2022, the MMP WORLD Project is one of the flagship
						initiatives of the BEM Foundation, operating under its official framework
						and mission. This project was developed to establish a robust crowdfunding
						and market-making ecosystem—specifically for supporting and stabilizing
						financial markets tied to BEM Foundation projects.
					</p>
					<h2>Purpose and Strategy</h2>
					<p>
						MMP WORLD functions with a reward-based crowdfunding model, where
						participants are incentivized for their financial contributions. The larger
						their role in fundraising and promotion, the greater the rewards they
						receive. This creates a dynamic and participatory financial ecosystem.
					</p>
					<p>
						At the core of its fundraising efforts is the BINARY Plan—one of the most
						powerful marketing structures globally. This plan is based on progression
						and team-building, enabling exponential growth and wider reach. Coupled with
						consistent financial disclosures and strong social media presence, MMP WORLD
						ensures transparency and engagement across all levels.
					</p>
					<p>
						Notably, the BEM Foundation itself does not act as a trader or investor in
						the market. All operational costs and project developments are funded from
						the personal capital of foundation executives—ensuring trust, integrity, and
						zero speculative risks with community funds. The foundation avoids high-risk
						trading activities, reinforcing its commitment to sustainability and
						real-world value creation.
					</p>
				</div>
			</div>

			<div
				id='mmp_projects'
				className='row pt-5'>
				<div className='col-12'>
					<h2>Market Making Begins with the BCN Token</h2>
					<p>
						To kickstart its role as a market maker, MMP WORLD selected the BCN
						Token—one of ten ready-to-launch projects within the BEM Foundation
						portfolio.
					</p>
					<h2>MMP WORLD’s Market Making Activities for BCN Include:</h2>
					<ul>
						<li>Injecting liquidity into the BCN market</li>
						<li>Trading BCN/USDT and BCN/TRX pairs to maintain volume</li>
						<li>Attracting and growing a base of BCN holders and active traders</li>
						<li>Initializing ready-to-launch projects within the BCN ecosystem</li>
						<li>Supporting new exchange listings and promotions for BCN</li>
						<li>Running advertising campaigns and airdrop events</li>
					</ul>
					<h2>Use of Crowdfunded Capital</h2>
					<h3>1. Token Purchases</h3>
					<p>
						A portion of the raised funds is used to buy BCN tokens—initially to provide
						financial support to the MMP WORLD project itself, and later to profit from
						price appreciation driven by the ecosystem’s growth. These profits are then
						used to fund investor rewards and manager incentives.
					</p>
					<h3>2. Driving Market Activity</h3>
					<p>
						To support a vibrant market, continuous trades are conducted to ensure BCN
						token activity and price discovery. High trade volume boosts confidence and
						allows deeper analysis for market participants.
					</p>
					<h3>3. Price Stability Measures</h3>
					<p>
						To prevent sudden price shocks caused by large transactions, market makers
						will strategically buy or sell to maintain price within a controlled range.
						This ensures investor confidence and smooth market operation, without
						manipulation or artificial inflation.
					</p>
					<h3>4. Deepening Liquidity Pools</h3>
					<p>
						Part of the funds is used to strengthen the liquidity pools. This is done by
						pairing BCN with base currencies (such as TRX or USDT). Half the funds are
						used to purchase BCN, while the other half remains in the paired
						asset—creating a more balanced and tradable environment.
					</p>
					<h2>Conclusion</h2>
					<p>
						The MMP WORLD Project represents a new generation of market-making
						strategy—fueled not by speculative trading, but by real community
						engagement, sustainable funding models, and professional management. With
						transparent operations and strategic application of capital, MMP WORLD
						supports the long-term growth of BEM Foundation projects and opens powerful
						financial opportunities for its global community.
					</p>
				</div>
			</div>

			<div
				id='mmp_goals'
				className='row pt-5'>
				<div className='col-12'>
					<h2>Liquidity Expansion and Ecosystem Growth</h2>
					<h3>Deepening the Liquidity Pool</h3>
					<p>
						To ensure high liquidity and reduce price impact during trades, MMP WORLD
						strategically allocates funds to the liquidity pool. The approach is simple
						and effective:
					</p>
					<ul>
						<li>
							50% of the allocated funds are used to buy the project token (e.g.,
							BCN).
						</li>
						<li>The other 50% is converted to a base currency such as TRX or USDT.</li>
					</ul>
					<p>
						Both components are then injected into the liquidity pool in equal
						proportions. This strengthens the market depth and allows for smoother
						transactions, minimizing slippage and ensuring stability for traders.
					</p>
					<h3>Advertising & Community Growth</h3>
					<p>
						Building visibility and trust is critical in a competitive crypto landscape.
						That’s why a portion of the crowdfunded capital is dedicated to high-impact
						advertising, including:
					</p>
					<ul>
						<li>Sponsorships and promotional campaigns</li>
						<li>Presence in major crypto gatherings and expos</li>
						<li>Targeted content on top-ranked crypto media platforms</li>
						<li>Influencer collaborations and social media strategy</li>
						<li>Technical content and SEO placement on leading blockchain sites</li>
					</ul>
					<h3>Exchange Listings and Credibility Boost</h3>
					<p>
						Being listed on top-tier exchanges significantly improves a token's
						reputation, accessibility, and trading volume. MMP WORLD allocates capital
						for:
					</p>
					<ul>
						<li>
							Paying initial listing fees on reputable centralized exchanges (CEXs)
						</li>
						<li>Meeting liquidity and technical integration requirements</li>
						<li>Building strategic relationships with global exchange networks</li>
					</ul>
					<h3>MMP WORLD Capital Ethics and Allocation Principles</h3>
					<p>
						Transparency and fairness are foundational values at MMP WORLD. That’s why:
					</p>
					<ul>
						<li>
							Funds will not be used to pay investor interests, staff rewards, or
							internal benefits before project development is fully complete.
						</li>
						<li>
							Only after a project achieves expansion milestones, rewards and interest
							payments will be distributed from genuine profits.
						</li>
						<li>
							Remaining profits will be reinvested into other BEM Foundation projects
							to fuel long-term growth across the ecosystem.
						</li>
					</ul>
					<h3>Strategic Milestones for the BCN Token</h3>
					<p>
						MMP WORLD has defined clear, measurable goals for the globalization of the
						BCN token:
					</p>
					<ul>
						<li>Listing on Top 10 exchanges on CoinMarketCap</li>
						<li>Target Price: $0.10+</li>
						<li>Market Cap Goal: $50,000,000+</li>
						<li>24H Trading Volume Target: $5,000,000+</li>
						<li>Liquidity Pool Depth: $1,000,000+</li>
						<li>Holder Base: 2,000,000+</li>
						<li>Telegram Community: 500,000+ members</li>
						<li>Twitter Audience: 1,000,000+ followers</li>
					</ul>
					<p>
						These milestones are aligned with a long-term growth strategy, driven by
						sustainable market-making and ethical fund management.
					</p>
				</div>
			</div>
		</div>
	),
};

export default mmpworld;
